<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10HdW6/tc-custom/9781504005395.jpg?1705836641596" alt="This image is the cover for the book Strike Force Bravo, Superhawks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strike Force Bravo, Superhawks
      </h1>
      <p class="bookDescription body article font2">
        <b>The counterterrorism battle shifts to Southeast Asia in the second explosive Superhawks thriller from Mack Maloney, bestselling author of the Wingman series </b><br/><br/> A terrorist cell with direct links to al-Qaeda’s leader captures Singapore’s Tonka Tower Hotel, one of the world’s tallest skyscrapers. The terrorists contact dozens of news organizations so the world can witness its destruction. News copters surround the building just as the Superhawks enter—rappelling from military choppers, guns blazing, disarming the terrorists’ bombs seconds before they detonate. It would seem that kudos are due, but the Superhawks are supposed to be top secret. The Pentagon bigwigs are steamed and send in a team of Navy SEALs to wrangle with the Superhawks. But al-Qaeda is hatching a new plot involving Stinger missiles. Can the Superhawks stop it in time? Or will the sprawling American military bureaucracy trip itself up before they even have a chance to try?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mack Maloney
      </h2>
      
      <p class="authorDescription body article">Mack Maloney is the author of numerous fiction series, including Wingman<i>, </i>ChopperOps<i>, </i>Starhawk, and Pirate Hunters, as well as <i>UFOs in Wartime &ndash; What They Didn&rsquo;t Want You to Know</i>. A native Bostonian, Maloney received a bachelor of science degree in journalism at Suffolk University and a master of arts degree in film at Emerson College. He is the host of a national radio show, <i>Mack Maloney&rsquo;s Military X-Files</i>.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d204039